import type { TProdutoStatusEnum } from '@/shared/interfaces'
import { HttpService } from '@/shared/lib'

export class GetStatusDoProduto extends HttpService {
  execute = async (idExternoProduto: number) => {
    return this.http.get<TProdutoStatusEnum>(`/api/v2/Produto/${idExternoProduto}/status`)
  }
}
